import { Avatar, Button, Checkbox, Col, List, Row } from "antd";
import React, { useState } from "react";
import Icon, { UserOutlined } from "@ant-design/icons";

import Auth from "config/auth";
import GlobalNavigation from "./navigation";
import { getColor } from "../../helper";

import CallModal from "@ui/candidate/call-modal";
import CandidateTableMessageModal from "@app/features/candidate-management/ui/candidate-management/candidate-table-message-modal";
import {
  SEND_MESSAGE_TAB,
  SMS_HISTORY_TAB,
  TEMPLATE_TAB
} from "@ui/messaging/send-message-modal";

import { ReactComponent as MessageIcon } from "@assets/images/svg/message.svg";
import { ReactComponent as PhoneCall } from "@assets/images/svg/phoneCall.svg";

import { SEND_SMS_MODAL_HEADER } from "../../constants/labels";
import Title from "antd/es/skeleton/Title";

const MESSAGE_TAB_ORDER = [SEND_MESSAGE_TAB, TEMPLATE_TAB, SMS_HISTORY_TAB];

function PersonList({ selectedIds, data, checkedForMsg }) {
  const modalObj = { isVisible: false, modalHeader: "" };
  const [modalObject, setModalObject] = useState(modalObj);

  // Message Modal Send Sms
  const resetModalFn = () => {
    setModalObject({ ...modalObj, isVisible: false });
  };

  const resultKeys = Object.keys(data || {});

  return (
    <>
      {/* send sms with template modal */}
      {modalObject.modalHeader === SEND_SMS_MODAL_HEADER && (
        <CandidateTableMessageModal
          personObjectId={modalObject.personObjectId}
          candidateObjectId={modalObject.candidateObjectId}
          candidateName={modalObject.candidateName}
          onClose={resetModalFn}
          defaultTab={SEND_MESSAGE_TAB}
          tabOrder={MESSAGE_TAB_ORDER}
        />
      )}

      {data &&
        resultKeys.map(keys => (
          <>
            {data[keys].length !== 0 && (
              <>
                <Title level={5}>{`${keys} (${data[keys]?.length || 0})`}</Title>
                <List
                  bordered
                  dataSource={data[keys] || []}
                  renderItem={item => (
                    <List.Item
                      onClick={() => {
                        if (keys === "Person") {
                          Auth.removeCandidateDetail();
                          Auth.setCandidateDetail({
                            personObjectId: item?.ObjectId,
                            candidateObjectId: item?.CandidateList[0]?.ObjectId,
                            candidateName: item?.Name
                          });
                        }
                      }}
                    >
                      <List.Item.Meta
                        description={
                          <>
                            <Row>
                              <Col span={22}>
                                <Avatar
                                  style={{
                                    backgroundColor: "green",
                                    verticalAlign: "middle"
                                  }}
                                  size="small"
                                >
                                  <UserOutlined />
                                </Avatar>
                                {keys === "Person" && (
                                  <Checkbox
                                    className="check-selected"
                                    onChange={e => checkedForMsg(e, item)}
                                    checked={selectedIds.includes(item.ObjectId)}
                                  />
                                )}

                                <span className="name-label">
                                  <GlobalNavigation type={keys} data={item} />
                                </span>

                                {item?.Badges &&
                                  Array.isArray(item?.Badges) &&
                                  item?.Badges.map((data, idx) => (
                                    <Button
                                      key={idx}
                                      style={{ backgroundColor: getColor(data.BadgeType) }}
                                      className="cursor-default"
                                    >
                                      {data?.Text}
                                    </Button>
                                  ))}

                                {item?.CandidateList && item?.CandidateList[0]?.SiteOfInterest && (
                                  <Button
                                    style={{ backgroundColor: getColor("PAY_TIER") }}
                                    className="cursor-default"
                                  >
                                    {item?.CandidateList[0]?.SiteOfInterest}
                                  </Button>
                                )}
                              </Col>

                              {/* CTA icons */}
                              <Col
                                span={2}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}
                              >
                                {keys === "Person" && (
                                  <CallModal
                                    personObjectId={item.ObjectId}
                                    candidateName={item.Name}
                                  >
                                    <Icon
                                      style={{ cursor: "pointer", fontSize: "20px" }}
                                      component={PhoneCall}
                                      className="status-icon"
                                    />
                                  </CallModal>
                                )}
                                {keys !== "Site" && (
                                  <Icon
                                    component={MessageIcon}
                                    className="status-icon"
                                    onClick={() => {
                                      setModalObject({
                                        isVisible: true,
                                        modalHeader: SEND_SMS_MODAL_HEADER,
                                        width: "40%",
                                        personObjectId: item?.ObjectId,
                                        candidateObjectId:
                                          item.CandidateList && item.CandidateList[0].ObjectId,
                                        type: "candidate",
                                        candidateName: item?.Name
                                      });
                                    }}
                                    style={{
                                      fontSize: "18px",
                                      color: "#25add5",
                                      position: "relative",
                                      left: "8px"
                                    }}
                                  />
                                )}
                              </Col>
                            </Row>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
              </>
            )}
          </>
        ))}
    </>
  );
}

export default PersonList;
